(() => {
  if (window.skullSizeGuideReady) return;
  window.skullSizeGuideReady = true;
  const dialog = document.getElementById('skull-size-guide-dialog');
  if (!dialog) return;
  let trigger, previousOverflow;
  document.addEventListener('change', event => {
    const guide = event.target.closest('[data-size-guide]');
    if (!guide || !event.target.matches('select')) return;
    const height = guide.querySelector('[name="height"]').value;
    const weight = guide.querySelector('[name="weight"]').value;
    const result = guide.querySelector('[data-size-result]');
    const icon = result.querySelector('.ssg-result-icon');
    const text = result.querySelector('p');
    guide.querySelectorAll('[data-selected]').forEach(cell => cell.removeAttribute('data-selected'));
    result.dataset.found = 'false';
    if (height === '' || weight === '') {
      icon.textContent = '↗';
      text.textContent = 'Selecciona ambos datos para ver tu talla recomendada.';
      return;
    }
    const matrix = JSON.parse(guide.querySelector('[data-size-matrix]').textContent);
    const size = matrix[Number(height)]?.[1]?.[Number(weight)];
    if (!size) {
      icon.textContent = '—';
      text.textContent = 'No hay una recomendación para esta combinación. Escríbenos y te ayudamos con tu talla.';
      return;
    }
    result.dataset.found = 'true';
    icon.textContent = size;
    text.textContent = 'Tu talla recomendada';
    const strong = document.createElement('strong');
    strong.textContent = `Talla ${size}`;
    text.append(strong);
    guide.querySelectorAll('tbody tr')[Number(height)].querySelectorAll('td')[Number(weight)].setAttribute('data-selected', '');
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-size-calculator]')) event.preventDefault();
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.pathname.replace(/\/$/, '') !== '/pages/guia-de-tallas' || ![location.hostname, 'skull.mx', 'www.skull.mx', 'jewerlyking.myshopify.com'].includes(url.hostname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (dialog.open) return;
    trigger = link;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    dialog.scrollTop = 0;
    dialog.querySelector('[data-size-guide-close]').focus({preventScroll: true});
  }, true);
  dialog.querySelector('[data-size-guide-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  // Keep Escape and Tab inside this layer, leaving the quick add's state intact.
  dialog.addEventListener('keydown', event => {
    event.stopPropagation();
    if (event.key === 'Escape') { event.preventDefault(); dialog.close(); }
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow || '';
    if (trigger?.isConnected) trigger.focus({preventScroll: true});
  });
})();
